import React from 'react';
import b_ from 'b_';
import type {useForm} from 'react-hook-form';
import {Controller} from 'react-hook-form';

import {BordomatikBox, CreativeBox} from 'client/common/types';

import I18N from 'assets/i18n/brandlift-project';

import {Select, Textinput} from 'client/common/components/lego';
import Block from 'client/common/components/block';
import BlockInput from 'client/common/components/block-input';
import SideBlock from 'client/common/components/side-block';

import {setImmut, INDUSTRY_SELECT_OPTIONS} from './utils';

const i18n = I18N.creatives.creativeSettings;
const i18nAdapted = I18N.creatives;
const b = b_.with('creative-settings-form');

interface SettingsBlockProps {
    box: CreativeBox | BordomatikBox;
    disabled: boolean;
    register: ReturnType<typeof useForm>['register'];
    errors: ReturnType<typeof useForm>['errors'];
    control: ReturnType<typeof useForm>['control'];
    handleBrandUpdate: (e: React.FocusEvent<HTMLInputElement>) => Promise<void>;
    updateSurveyBoxContext: (box: unknown) => Promise<void>;
}

export default function SettingsBlock(props: SettingsBlockProps) {
    const {box, disabled, register, errors, control, handleBrandUpdate, updateSurveyBoxContext} = props;

    const handleIndustryChange = (_: any, cb: any) => async (e: any) => {
        cb(e.target.value);

        await updateSurveyBoxContext(setImmut(box, 'context.industry', e.target.value));
    };

    return (
        <Block
            header={i18n.new.settings.title}
            description={i18n.new.settings.desc}
        >
            <BlockInput title={i18n.new.brandLabel} error={errors.brandName}>
                <Textinput
                    size='m'
                    name='brandName'
                    placeholder={i18n.placeholders.brandInput}
                    onBlur={handleBrandUpdate}
                    disabled={disabled}
                    view='dl'
                    controlRef={register({
                        required: i18n.validationMsg.brand,
                        validate: (v: string) => v.trim() ? true : i18n.validationMsg.brand,
                    })}
                    state={errors.brandName && 'error'}
                />
            </BlockInput>
            <BlockInput title={i18n.new.industryLabel} error={errors.industry}>
                <Controller
                    control={control}
                    name='industry'
                    rules={{required: i18n.validationMsg.industry[box.name]}}
                    render={({onChange, onBlur, value}) => {
                        return (
                            <Select
                                className={b('select')}
                                options={INDUSTRY_SELECT_OPTIONS}
                                size='m'
                                width='max'
                                view='dl-clear'
                                value={value}
                                placeholder={i18n.placeholders.industryInput}
                                disabled={disabled}
                                onChange={handleIndustryChange(value, onChange)}
                                onBlur={onBlur}
                            />
                        );
                    }}
                />
            </BlockInput>
            <SideBlock
                imageSet='video'
                text={i18nAdapted[`${box.name}Settings`].sideBlock.settingsText}
                link={i18nAdapted[`${box.name}Settings`].sideBlock.settingsLink}
            />
        </Block>
    );
}
